import {
  Lightbox,
  Mediaquery,
  Swap
} from 'formstone/jquery';

window.SiteReady(($) => {
  console.log('Init: Formstone');

  // Search / Newsleter Modal

  $(window).on('lightbox:open', (e) => {
    let $handle = $(e.detail.el);

    if ($handle.hasClass('js-search_modal_handle')) {
      setTimeout(() => {
        $('.fs-lightbox.search_lightbox').find('input[type="text"]').first().focus();
      }, 50);
    }

    if ($handle.hasClass('js-newsletter_modal_handle')) {
      setTimeout(() => {
        $('.fs-lightbox.newsletter_lightbox').find('input[type="email"]').first().focus();
      }, 50);
    }
  });

  //

  $('.js-swap').swap();
  $('.js-lightbox').lightbox({
    videoProviders: {
      sproutvideo: {
        pattern: /(.*(vids\.io|sproutvideo\.com)\/.*)\?/,
        format: (parts) => {
          return parts[1];
        }
      }
    }
  });

  // Geo Adaptors

  window.showGeoModal = window.showGeoModal || false;

  if (window.showGeoModal) {
    $('.js-geo_modal_handle')[0].click();
  }

  // Destini

  let hash = window.location.hash;

  if (hash.indexOf('modal-') > -1 || hash.indexOf('lightbox-') > -1) {
    let blockId = hash.replace('#modal-', '').replace('#lightbox-', '').replace('#', '');
    let $lightbox = $('#' + blockId + ' .js-lightbox');

    if ($lightbox.length) {
      console.log('Open Modal: #' + blockId);

      $lightbox[0].click();
    }
  }

});
